import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { TransferListItem } from '../types'
import { UseTransferListProps } from './useTransferList'

export type UseFilteredList = {
  filter: string
  filteredLeft: TransferListItem[]
  filteredRight: TransferListItem[]
  setFilter: Dispatch<SetStateAction<string>>
}

export const useFilteredList = ({ leftList, rightList }: UseTransferListProps): UseFilteredList => {
  const [filter, setFilter] = useState<string>('')
  const [left, setLeft] = useState<TransferListItem[]>(leftList)
  const [right, setRight] = useState<TransferListItem[]>(rightList)

  const filterList = (list: TransferListItem[]): TransferListItem[] =>
    list.filter(({ label }: TransferListItem): boolean =>
      label.toLowerCase().includes(filter.toLowerCase()),
    )

  useEffect(() => {
    if (filter.length > 0) {
      setLeft(filterList(leftList))
      setRight(filterList(rightList))
    } else {
      setLeft(leftList)
      setRight(rightList)
    }
  }, [filter, leftList, rightList])

  return {
    filter,
    filteredLeft: left,
    filteredRight: right,
    setFilter,
  }
}
